// Must be in sync with API
// https://bitbucket.org/neuroflash/neuroflash_api/src/d9c60b72bdeae58915e5775258122a56e134426d/app/Http/Middleware/AddSentryHeader.php#lines-24
export const transactionIdHeaderName = 'X-TRANS-ID';
